export const SPECIAL_INSTALL_DATES_OPTIONS = {
  'True': true,
  'False': false,
};
